import React from 'react'
import { Affix, Box, Center, Group, Stack, Table, Transition } from '@mantine/core'
import { useWindowScroll } from '@mantine/hooks'

import { PriceInterval, Product } from 'types/domain'

import ProductIntro from './ProductIntro'
import Platform from './Platform'
import Campaign from './Campaign'
import Service from './Service'

type Props = {
  products: Product[]
}

const Header = ({ products }: Props) => {
  return (
    <Table
      horizontalSpacing={16}
      sx={{
        'tbody tr td': {
          padding: 0,
        },
      }}
    >
      <tbody>
        <tr>
          <td width="226"></td>
          {products.map((product) => (
            <td key={product.code} width="226">
              <ProductIntro product={product} priceInterval={PriceInterval.Year} />
            </td>
          ))}
        </tr>
      </tbody>
    </Table>
  )
}

const ProductDetail = ({ products }: Props) => {
  const [scroll] = useWindowScroll()

  return (
    <Box w="100%">
      <Affix position={{ top: '57px' }} zIndex={1002} className="hidden sm:block">
        <Transition transition="fade" mounted={scroll.y > 1600}>
          {(transitionStyles) => (
            <Center
              bg="white"
              w="calc(100vw - 10px)"
              h={200}
              opacity={0.8}
              className="border-0 border-b border-solid border-gray-2 backdrop-blur"
              style={transitionStyles}
            >
              <Group w={1194} spacing={0}>
                <Header products={products} />
              </Group>
            </Center>
          )}
        </Transition>
      </Affix>
      <Header products={products} />
      <Box mt={12}>
        <Stack spacing={30}>
          <Platform />
          <Campaign />
          <Service />
        </Stack>
      </Box>
    </Box>
  )
}

export default ProductDetail
